export const leadformClasses = {
  leadform: '.js-leadform',
  panel: '.lead-constructor__panel',
  nextButton: '.js-lead-constructor__next',
  backButton: '.js-lead-constructor__back'
};

export const leadformTagNames = {
  form: 'form',
  fields: [
    'select',
    'input',
    'textarea'
  ]
};

export const activeClass = 'active';
